import CustomDropdownInput from "components/CustomDropdownInput";
import CustomTextInput from "components/CustomTextInput";
import React from "react";
import { Row, Col } from "reactstrap";
import t from "utils/Lang";
import moment from "moment";
import CustomFileInput from "components/CustomFileInput";

type ContractInfoProps = {
  contractTypes: Array<any>;
  purposeTypes: Array<any>;
  updateAttr: (attribute: string, value: any) => void;
  data: any;
  errorData: any;
  isViewContract: boolean;
  fieldIsInvalid: (err: any) => boolean;
  siteAddress: string;
  periodTypes: Array<any>;
  linkContracts: Array<any>;
  internalCode?: string;
};

const ContractInfo = ({
  contractTypes,
  updateAttr,
  data,
  errorData,
  isViewContract,
  fieldIsInvalid,
  purposeTypes,
  siteAddress,
  periodTypes,
  linkContracts,
  internalCode,
}: ContractInfoProps) => {
  const diffMonth = () => {
    if (!data.contract_valid_to) return "";
    const currentDate = moment().format("YYYY-MM-DD");
    return moment(data.contract_valid_to).diff(moment(currentDate), "months");
  };
  const rentTime = () => {
    if (!data.available_from || !data.available_to) return "";
    return moment(data.available_to).diff(
      moment(data.available_from),
      "months"
    );
  };
  const uiConfigs = [
    {
      attributeName: "name",
      type: "text",
      label: t().site_contract_modal__name + " *",
      size: 6,
    },
    {
      attributeName: "store_code",
      type: "text",
      label: t().contract_store_code,
      size: 6,
      isDisabled: true,
      value: internalCode,
      inactive: !internalCode,
    },
    {
      attributeName: "contract_type_id",
      type: "dropdown",
      options: contractTypes.map((type) => ({
        label: type.name,
        value: type.id,
      })),
      label: t().site_contract_modal__type + " *",
      size: 6,
    },
    {
      attributeName: "parent_contract_id",
      type: "dropdown",
      options: linkContracts.map((type) => ({
        label: type.name,
        value: type.id,
      })),
      label: t().contract_link + " *",
      size: 6,
      inactive: data.contract_type_id
        ? contractTypes.find((el) => el.id === data.contract_type_id)?.code !==
          "Appendix"
        : true,
    },
    {
      attributeName: "contract_code",
      type: "text",
      label: t().site_contract_modal__contract_number + " *",
      size: 6,
    },
    {
      attributeName: "contract_purpose_id",
      type: "dropdown",
      options: purposeTypes.map((type) => ({
        label: type.name,
        value: type.id,
      })),
      label: t().site_contract_modal__rental_purpose,
      size: 6,
    },
    {
      attributeName: "payment_period_type_id",
      type: "dropdown",
      options: periodTypes.map((type) => ({
        label: type.name,
        value: type.id,
      })),
      label: t().site_contract_modal__period_type,
      size: 6,
    },
    {
      attributeName: "payment_period_monthly_cycle",
      type: "text",
      label: t().contract__payment_cycle,
      isNumeric: true,
      size: 6,
    },
    {
      attributeName: "contract_signed_date",
      type: "date",
      label: t().site_contract_modal__date + " *",
      size: 6,
    },
    {
      attributeName: "blank_1",
      type: "blank",
      label: "",
      size: 6,
      inactive: data.contract_type_id
        ? contractTypes.find((el) => el.id === data.contract_type_id)?.code ===
          "Appendix"
          ? !internalCode
          : internalCode
        : false,
    },
    {
      attributeName: "contract_valid_from",
      type: "date",
      label: t().site_contract_modal__start + " *",
      size: 6,
    },
    {
      attributeName: "contract_valid_to",
      type: "date",
      label: t().site_contract_modal__expire + " *",
      size: 6,
    },
    {
      attributeName: "diff_month",
      type: "text",
      label: t().site_contract_modal__month_expire,
      isDisabled: true,
      size: 12,
      isNumeric: false,
      value: diffMonth(),
    },
    {
      attributeName: "available_from",
      type: "date",
      label: t().site_contract_modal__rental_from + " *",
      size: 6,
    },
    {
      attributeName: "available_to",
      type: "date",
      label: t().site_contract_modal__rental_to + " *",
      size: 6,
    },
    {
      attributeName: "rent_time",
      type: "text",
      label: t().site_contract_modal__rent_time,
      isDisabled: true,
      size: 12,
      isNumeric: false,
      value: rentTime(),
    },
    {
      attributeName: "rental_entity_tax_number",
      type: "text",
      label: t().site_contract_modal__host_id,
      size: 6,
    },
    {
      attributeName: "rental_entity_name",
      type: "text",
      label: t().site_contract_modal__host_name,
      size: 6,
    },
    {
      attributeName: "rental_entity_address",
      type: "text",
      label: t().site_contract_modal__address,
      size: 12,
      isDisabled: true,
      value: siteAddress,
    },
    {
      attributeName: "contract_file",
      type: "file",
      label: t().contract_file,
      size: 6,
    },
  ];
  return (
    <>
      <h4 className="site-summary__label-title">
        {t().site_contract_modal__contract_info}
      </h4>
      <Row>
        {uiConfigs
          .filter((el) => !el.inactive)
          .map((layoutItem, idx) => {
            // if (layoutItem.attributeName === 'diff_month') {
            //   return (
            //     <Col
            //       key={layoutItem.attributeName || `${idx}`}
            //       sm={{ size: layoutItem.size, offset: 0 }}
            //     >
            //       <CustomTextInput
            //         key={layoutItem.attributeName || `${idx}`}
            //         disabled
            //         type={layoutItem.type}
            //         callback={updateAttr}
            //         labelText={layoutItem.label}
            //         attributeName={layoutItem.attributeName}
            //         value={diffMonth()}
            //       />
            //     </Col>
            //   );
            // }
            if (layoutItem.type == "blank") {
              return (
                <Col
                  key={layoutItem.attributeName || `${idx}`}
                  sm={{ size: layoutItem.size, offset: 0 }}
                />
              );
            } else if (layoutItem.type == "file") {
              return (
                <Col
                  key={layoutItem.attributeName || `${idx}`}
                  sm={{ size: layoutItem.size, offset: 0 }}
                >
                  <CustomFileInput
                    callback={updateAttr}
                    data={data}
                    labelText={layoutItem.label}
                    attribute={layoutItem.attributeName}
                  />
                </Col>
              );
            }
            if (layoutItem.type == "dropdown") {
              return (
                <Col
                  key={layoutItem.attributeName || `${idx}`}
                  sm={{ size: layoutItem.size, offset: 0 }}
                >
                  <CustomDropdownInput
                    callback={updateAttr}
                    data={data}
                    options={layoutItem.options || []}
                    labelText={layoutItem.label}
                    attributeName={layoutItem.attributeName}
                    invalid={fieldIsInvalid(
                      errorData?.[layoutItem.attributeName]
                    )}
                    formFeedbackText={errorData?.[layoutItem.attributeName]}
                    disabled={isViewContract}
                  />
                </Col>
              );
            } else {
              return (
                <Col
                  key={layoutItem.attributeName || `${idx}`}
                  sm={{ size: layoutItem.size, offset: 0 }}
                >
                  <CustomTextInput
                    key={layoutItem.attributeName || `${idx}`}
                    disabled={isViewContract || layoutItem.isDisabled}
                    type={layoutItem.type}
                    isNumeric={layoutItem.isNumeric || false}
                    callback={updateAttr}
                    data={data}
                    labelText={layoutItem.label}
                    attributeName={layoutItem.attributeName}
                    value={layoutItem.value}
                    invalid={fieldIsInvalid(
                      errorData?.[layoutItem.attributeName]
                    )}
                    formFeedbackText={errorData?.[layoutItem.attributeName]}
                  />
                </Col>
              );
            }
          })}
      </Row>
    </>
  );
};

export default ContractInfo;
